import type { BenchmarkReport } from '../../types/benchmark';

interface ErrorsBySeverityCardProps {
  report: BenchmarkReport;
}

export function ErrorsBySeverityCard({ report }: ErrorsBySeverityCardProps) {
  const severities = [
    { label: 'Critiques', count: report.errors_by_severity.critical, color: 'text-red-600', icon: '🔴' },
    { label: 'Moyennes', count: report.errors_by_severity.medium, color: 'text-orange-600', icon: '🟡' },
    { label: 'Mineures', count: report.errors_by_severity.minor, color: 'text-yellow-600', icon: '🟢' },
  ];

  return (
    <div className="bg-white p-6 border rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Erreurs par sévérité</h3>

      <div className="space-y-4">
        {severities.map((severity) => (
          <div key={severity.label} className="flex items-center justify-between">
            <div className="flex items-center">
              <span className="text-2xl mr-3">{severity.icon}</span>
              <span className="text-sm font-medium">{severity.label}</span>
            </div>
            <span className={`text-2xl font-bold ${severity.color}`}>
              {severity.count}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t">
        <div className="text-sm text-gray-600">
          Total: <span className="font-semibold">
            {report.errors_by_severity.critical + report.errors_by_severity.medium + report.errors_by_severity.minor}
          </span> erreurs
        </div>
      </div>
    </div>
  );
}
